import { Headline, Text } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from '~/app/i18n/i18n';
import { Header } from '~/components/image-selection-tile/style/tile-selection-section-style';
import { DATA_TEST_ID } from '~/test/data-test-id';
import { getHeaderId } from '~/utils/a11y-ids';

export function OptionsHeader({
	id,
	step,
	title,
	total,
	tabIndex,
}: {
	id?: string;
	step: number;
	title: string;
	total: number;
	tabIndex?: number;
}) {
	const { i18n } = useI18n();

	return (
		<Header
			id={getHeaderId(id)}
			tabIndex={tabIndex}
			aria-label={`${i18n('ngc.common.steps', { step, total })} ${title}`}>
			{total ? (
				<Text
					data-testid={DATA_TEST_ID.SELECTION_STEP_STEPS}
					className="steps"
					tag="p"
					variant={{ type: 'copy', order: '3', style: 'normal' }}>
					{i18n('ngc.common.steps', { step, total })}
				</Text>
			) : (
				<></>
			)}
			<Headline
				data-testid={DATA_TEST_ID.SELECTION_STEP_TITLE}
				className="spacing-bottom"
				tag="h2"
				variant={{ type: 'headline', order: '3', weight: 'normal' }}>
				{title}
			</Headline>{' '}
		</Header>
	);
}
